import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { useDevices, useTradeInConfiguration } from "@jti/rest-api";
import { updateTradeInOrderAttributes } from "@jti/store";
import { Select, useTranslations } from "@jti/ui";
import { useCartTradeInError } from "../../../../pages/CartPage/components/hooks/useCartTradeInError";
const devicesToSelectOptionsAdapter = (devices) => {
    if (!devices) {
        return [];
    }
    return devices.map(({ deviceId, deviceName }) => ({
        value: deviceId,
        label: deviceName ?? deviceId,
    }));
};
export const TradeInSelect = ({ sku }) => {
    const { __ } = useTranslations();
    const { data: responseData, isLoadingData: isLoadingDevices } = useDevices();
    const registeredDevices = responseData?.data;
    const dispatch = useDispatch();
    const { errorMessage, setError } = useCartTradeInError();
    const { defaultDevices, isUsingRegisteredDevices, isLoading: isLoadingTradeInConfiguration, } = useTradeInConfiguration();
    const loading = isLoadingDevices || isLoadingTradeInConfiguration;
    const defaultDevicesOptions = useMemo(() => (defaultDevices || []).map((device) => ({
        deviceId: device,
        deviceName: device,
    })), [defaultDevices]);
    const devices = isUsingRegisteredDevices ? registeredDevices : defaultDevicesOptions;
    const selectAdaptedDevices = useMemo(() => devicesToSelectOptionsAdapter(devices), [devices]);
    const preselectedDevice = selectAdaptedDevices.length === 1 && !loading ? selectAdaptedDevices[0] : undefined;
    const onValueChange = useCallback((newValue) => {
        const { value, label } = newValue;
        const serialNumber = isUsingRegisteredDevices ? value : "";
        setError(undefined);
        dispatch(updateTradeInOrderAttributes({
            traded_in_new_sku: sku,
            traded_in_model: label,
            traded_in_serial_number: serialNumber,
        }));
    }, [dispatch, sku, isUsingRegisteredDevices]);
    useEffect(() => {
        if (preselectedDevice) {
            onValueChange(preselectedDevice);
        }
    }, [preselectedDevice, onValueChange]);
    return (_jsx(Select, { placeholder: __("cart.cart_item.trade_in.select.placeholder"), isIconHidden: true, options: selectAdaptedDevices, isLoading: loading, onChange: onValueChange, isError: !!errorMessage, isHelperTextVisible: !!errorMessage, errorText: errorMessage, ...(preselectedDevice ? { value: preselectedDevice } : {}) }));
};
//# sourceMappingURL=TradeInSelect.js.map